if (!window.__ddReviewTriggerBound) {
  window.__ddReviewTriggerBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-dd-open-reviews]');
    if (!trigger) return;

    if (typeof window.openReviewsLightbox === 'function') {
      window.openReviewsLightbox(trigger);
      return;
    }

    document.dispatchEvent(
      new CustomEvent('dd:open-reviews', {
        bubbles: true,
        detail: { trigger },
      })
    );
  });
}
